'use client';

import {useContext, useSyncExternalStore, useCallback} from 'react';
import {ActiveScreenIdSubscriptionContext} from './ActiveScreenIdProvider';

/**
 * Hook that returns whether a specific screen is the *primary* active screen
 * (i.e. selectedScreenIds[0]). Only one screen at a time is "active" in this
 * sense — used for canvas action buttons, history popover, accordion, etc.
 *
 * Only re-renders when the boolean value flips for THIS specific screenId.
 *
 * For multi-select highlights ("is this screen anywhere in the selection?"),
 * use useIsScreenSelected instead.
 */
export function useIsActiveScreen(screenId: string): boolean {
  const {subscribe, getSnapshot} = useContext(
    ActiveScreenIdSubscriptionContext,
  );

  const getIsActive = useCallback(
    () => getSnapshot()[0] === screenId,
    [getSnapshot, screenId],
  );

  return useSyncExternalStore(subscribe, getIsActive, getIsActive);
}
